import React from 'react';
import { useSelector } from 'react-redux';
import { getFirstPitchState } from './store/selectors/getFirstPitchState';
import FirstPitch from './FirstPitch';

const FirstPitchDataContainer = ({
    showImage = false
}) => {
    const {
        isLoading,
        firstPitchTime,
        isWarmup,
        venueName
    } = useSelector(getFirstPitchState);

    return (
        firstPitchTime ? (
            <FirstPitch
                firstPitchTime={ firstPitchTime}
                venueName={venueName}
                isWarmup={isWarmup}
                isLoading={isLoading}
                showImage={showImage}
            />
        ) : null
    );
};

export default FirstPitchDataContainer;
